import { render } from "./TermsMain.vue?vue&type=template&id=736ed656&scoped=true"
import script from "./TermsMain.vue?vue&type=script&lang=js"
export * from "./TermsMain.vue?vue&type=script&lang=js"

import "./TermsMain.vue?vue&type=style&index=0&id=736ed656&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736ed656"]])

export default __exports__